import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import {PhotoTypes} from 'entities/messages'
import {openGallery, setCurrentImage, setGalleryIsPhotoList} from 'entities/profile'
import {setAvatar, UploadAvatar, useUser} from 'entities/user'
import {EditButton} from 'features/buttons/editButton'
import {GetDirectUploadUrlPhoto, UploadMediaToBucket} from 'shared/api/images'
import {mediaVariants, names} from 'shared/lib'
import {UserStatus} from 'shared/types'
import {Avatar} from 'shared/ui/avatar'
import {Loader} from 'shared/ui/loader'
import styles from './styles.module.scss'

type AvatarBoxProps = {
  canEdit?: boolean
  type: PhotoTypes | null
  src?: string
  alt?: string
  isOnline?: boolean
  className?: string
  showEdit?: boolean
  hideStatus?: boolean
}

export const AvatarBox: FC<AvatarBoxProps> = ({canEdit, src, alt, isOnline, className, showEdit, hideStatus, type}) => {
  const {status} = useUser()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const onSave = async (file: File) => {
    setIsLoading(true)
    const {data: uploadUrls} = await GetDirectUploadUrlPhoto({count: 1, mediaType: 'avatar'})
    const [{uploadUrl, key}] = uploadUrls

    await UploadMediaToBucket(uploadUrl, file)

    const {data: avatar} = await UploadAvatar(key)

    dispatch(setAvatar(avatar.image.url))
    setIsLoading(false)
  }

  const editAvatarHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!(event.target.files && event.target.files.length > 0)) return
    onSave(event.target.files[0]).catch(console.error)
    event.target.value = ''
  }

  const onClickHandler = () => {
    if (!src || !type) return

    dispatch(openGallery())
    dispatch(setGalleryIsPhotoList(false))
    dispatch(setCurrentImage({index: 0, type, src, id: 'avatar'}))
  }

  return (
    <div className={names(styles.avatarBox, className)}>
      <div
        className={names(styles.avatarWrapper, showEdit ? styles.showEdit : '', canEdit && src ? styles.pointer : '')}
        onClick={onClickHandler}
      >  {canEdit && !isLoading && status === UserStatus.ACTIVE ?
          <div className={styles.editAvatar}>
            <EditButton onChange={editAvatarHandler} />
          </div>
          : null}
        {isLoading ?
          <div className={styles.loadingAvatar}>
            <Loader innerColor='white' />
          </div>
          : null}
        <Avatar
          sx={{width: 150, height: 150}}
          src={src + (type === PhotoTypes.avatar ? mediaVariants.square256 : '')}
          alt={alt}
          className={styles.item}
        />
      </div>
      {!hideStatus ?
        <div className={names(styles.status, isOnline && styles.active)} />
        : null}
    </div>
  )
}
